import Vue from 'vue'
import Vuex from 'vuex'

// multiple store modules
import Common from '@/stores/modules/common'
import Auth from '@/stores/modules/auth/auth'
import ZoneNews from '@/stores/modules/zoning/zoneNews'
import EstateNews from '@/stores/modules/estate/estateNews'
import User from '@/stores/modules/user/user'
import Log from '@/stores/modules/log/log'
import Setting from '@/stores/modules/setting/setting'
import Notif from '@/stores/modules/notif/notif'
import Ads from '@/stores/modules/ads/ads'
import StatisticChart from '@/stores/modules/statistic/chart'
import OtherProvince from '@/stores/modules/other/province'
import OtherDistrict from '@/stores/modules/other/district'
import OtherCommune from '@/stores/modules/other/commune'
import OtherZoneType from '@/stores/modules/other/zoneType'
import EstateForm from '@/stores/modules/other/estateForm'
import EstateType from '@/stores/modules/other/estateType'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  isLoading: false
}

const mutations = {
  toggleSidebarDesktop(state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile(state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set(state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    common: Common,
    auth: Auth,
    zoneNews: ZoneNews,
    estateNews: EstateNews,
    user: User,
    log: Log,
    setting: Setting,
    notif: Notif,
    ads: Ads,
    statisticChart: StatisticChart,
    province: OtherProvince,
    district: OtherDistrict,
    commune: OtherCommune,
    zoneType: OtherZoneType,
    estateForm: EstateForm,
    estateType: EstateType,
  }
})
